<template>
  <footer
    id="dine-in-form-footer"
    class="position-fixed bg-white w-85 border-top p-4 text-right"
  >
    <b-button
      variant="ghost"
      class="btn-cancel px-4 rounded-pill mr-3"
      @click="handleCancelButton"
      :disabled="storeDineInLoading || branchesLoading"
    >
      Cancel
    </b-button>
    <b-button
      variant="primary"
      class="btn-save px-4 rounded-pill"
      @click="handleAddTable"
      :disabled="storeDineInLoading || branchesLoading"
    >
      {{ saveButtonText }}
    </b-button>
  </footer>
</template>

<script>
import {
  defineComponent,
  computed,
  onMounted,
  onBeforeUnmount,
} from "@vue/composition-api";

export default defineComponent({
  setup(_, { root }) {
    const storeDineInLoading = computed(
      () => root.$store.state.storeDineIn.loading
    );
    const branchesLoading = computed(() => root.$store.state.branches.loading);

    const applyAppContentHeight = () => {
      document.documentElement.style.setProperty(
        "--app-content-width",
        `${document.getElementById("app-content").clientWidth}px`
      );
    };

    root.$router.onReady(() => {
      applyAppContentHeight();
    });

    addEventListener("resize", () => {
      applyAppContentHeight();
    });

    const routeName = computed(() => root.$route.name || null);
    const isRouteNameCreateGroupTable = computed(
      () =>
        (routeName.value && routeName.value === "DineInCreateTableGroup") ||
        false
    );
    const isRouteNameUpdateGroupTable = computed(
      () =>
        (routeName.value && routeName.value === "DineInUpdateTableGroup") ||
        false
    );

    const message = computed(() => {
      if (isRouteNameCreateGroupTable.value)
        return "Are you sure you want to cancel the creation of this table group?";
      else if (isRouteNameUpdateGroupTable.value)
        return "Are you sure you want to cancel the updates made to this table group?";
    });

    const handleCancelButton = () => {
      root.$emit("isUntouchedForm");
    };

    const handleAddTable = () => {
      root.$emit("validateTableCreation");
    };

    const saveButtonText = computed(() =>
      root.$route.name === "DineInCreateTableGroup"
        ? "Add Table Group"
        : "Save Changes"
    );

    onMounted(() => {
      root.$on("touchedForm", () => {
        root.$emit("bv::show::modal", "dine-in-prompts", {
          title: "Leave without saving?",
          message: message.value,
          buttons: [
            {
              label: "Leave this page",
              variant: "ghost btn-cancel",
              action: "handleLeavePage",
            },
            {
              label: "Stay on this page",
              variant: "primary",
              action: "handleStayOnPage",
            },
          ],
        });
      });
      root.$on("untouchedForm", () => root.$router.go(-1));
    });

    onBeforeUnmount(() => {
      root.$off("touchedForm");
      root.$off("untouchedForm");
    });

    return {
      handleCancelButton,
      handleAddTable,
      saveButtonText,
      storeDineInLoading,
      branchesLoading,
    };
  },
});
</script>


<style lang="scss" scoped>
#dine-in-form-footer {
  bottom: 0;
  width: var(--app-content-width);
  padding-right: calc(100px + 1.5rem) !important;
  z-index: 1;
}
</style>
